import styled from 'styled-components';
import { Stack, Typography } from '@mui/material';
import useConversationShopperStatus from '../../hooks/useConversationShopperStatus';
import { chatSelectors, useAppSelector } from '@vs-online-only-app/state';
import { UserAvatar } from '@vs-online-only-app/ui';
import { SelectedConversationActionsMenu } from './SelectedConversationActionsMenu';
import { useSelectedHeroConversation } from '../../hooks/useSelectedHeroConversation';

const Wrapper = styled(Stack)`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  grid-column: 1/3;
  border-bottom: 1px solid ${({ theme }) => theme.palette.divider};
  padding: ${({ theme }) => theme.spacing(1.5, 3)};
  position: relative;
  z-index: 2;
`;

const SelectedActiveConversationHeader = () => {
  const selectedConversation = useAppSelector(
    chatSelectors.selectSelectedConversation,
  );
  const conversation = useSelectedHeroConversation();
  const shopperStatus = useConversationShopperStatus({
    conversationId: selectedConversation?.id,
  });

  if (!conversation) {
    return null;
  }

  return (
    <Wrapper>
      <Stack direction="row" gap={2}>
        {shopperStatus && (
          <>
            <UserAvatar
              fallbackCharacter={conversation.conversationStarter.firstName
                .charAt(0)
                .toUpperCase()}
              hasStatusIndicator
              isOnline={!shopperStatus.isAway}
              color="#E95D11" // Bambuser orange
            />
            <Stack direction="column" alignItems="flex-start">
              <Typography fontWeight="bold">
                {conversation.conversationStarter.firstName}
              </Typography>
              <Typography variant="caption" color="textSecondary">
                {shopperStatus.lastSeenTimeAgo}
              </Typography>
            </Stack>
          </>
        )}
      </Stack>
      <SelectedConversationActionsMenu />
    </Wrapper>
  );
};

export default SelectedActiveConversationHeader;
